var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_chart",
    "data-name": "vuesax/bulk/chart",
    transform: "translate(-428 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart-2",
    "data-name": "chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(428 252)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M18.75,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h18a.755.755,0,0,1,.75.75A.755.755,0,0,1,18.75,1.5Z",
    transform: "translate(430.25 273.25)",
    fill: "#fd4082",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2.6,0H1A1,1,0,0,0,0,1V9.62a1,1,0,0,0,1,1H2.6a1,1,0,0,0,1-1V1A1,1,0,0,0,2.6,0Z",
    transform: "translate(431 260.38)",
    fill: "#fd4082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M2.6,0H1A1,1,0,0,0,0,1V12.81a1,1,0,0,0,1,1H2.6a1,1,0,0,0,1-1V1A1,1,0,0,0,2.6,0Z",
    transform: "translate(438.2 257.19)",
    fill: "#fd4082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M2.6,0H1A1,1,0,0,0,0,1V16a1,1,0,0,0,1,1H2.6a1,1,0,0,0,1-1V1A1,1,0,0,0,2.6,0Z",
    transform: "translate(445.4 254)",
    fill: "#fd4082"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.3d1e03a2ab846e8f1440532f58830ce9.svg";
export { ForwardRef as ReactComponent };